<template>
  <div class="index-page">
    <navbar/>
    <div class="carousel carousel-slider" id="enclosedSlide">
      <a class="carousel-item" href="#one!">
        <img src="../assets/slides/New folder/news/IMG_0407.jpg" alt="prc2017-platinum reasoning contest">
      </a>
      <a class="carousel-item" href="#one!">
        <img src="../assets/slides/New folder/PLATINIUM 3.jpg" alt="prc2018-platinum reasoning contest 2018 Africa">
      </a>
      <a class="carousel-item" href="#four!"><img src="../assets/logo_bg.png" alt="pmgc logo"></a>
      <a class="carousel-item" href="#four!"><img src="../assets/PRC2018.jpg" alt="pmgc logo"></a>
      <a class="carousel-item" href="#one!">
        <img src="../assets/slides/New folder/news/this is my schl.png" alt="platinum reasoning contest first position">
      </a>
      <a class="carousel-item" href="#two!"><img src="../assets/slides/New folder/news/IMG_0363.jpg" alt="FIRST POSITION PRC2017 redeemer university computer science"></a>
      <a class="carousel-item" href="#two!"><img src="../assets/slides/New folder/news/IMG_0354.jpg" alt="second position prc2017 American uinversity of nigeria computer science"></a>
      <a class="carousel-item" href="#two!"><img src="../assets/slides/New folder/news/IMG_0345.jpg" alt="third position OAU, computr science maryam16 years old"></a>
      <a class="carousel-item" href="#two!"><img src="../assets/slides/New folder/news/IMG_0380.jpg" alt="top three winners of prc2017 transcort hilton, oluwafemi, salisu, folasewa maryam"></a>
      <a class="carousel-item" href="#two!"><img src="../assets/slides/New folder/news/IMG_0415.jpg" alt="first-position-5000 thousand, second-position-300 thousand, third-position-200 thousand"></a>
      <a class="carousel-item" href="#four!"><img src="../assets/slides/New folder/sean-kong-491810-unsplash.jpg"></a>
      <a class="carousel-item" href="#four!"><img src="../assets/slides/New folder/85fifteen-323874-unsplash.jpg"></a>
      <a class="carousel-item" href="#four!"><img src="../assets/slides/New folder/glenn-carstens-peters-203007-unsplash.jpg"></a>
      <a class="carousel-item" href="#four!"><img src="../assets/slides/New folder/neonbrand-570366-unsplash.jpg"></a>
      <a class="carousel-item" href="#four!"><img src="../assets/slides/New folder/nick-morrison-325805-unsplash.jpg"></a>
      <a class="carousel-item" href="#four!"><img src="../assets/slides/New folder/sergey-zolkin-192937-unsplash.jpg"></a>
      <a class="carousel-item" href="#four!"><img src="../assets/slides/New folder/stefan-stefancik-257625-unsplash.jpg"></a>
      <div class="header-text text-center center-align white-text">
        <h4 class="text-center center-align">PLATINUM MINDS GLOBAL COMPANY<wbr/></h4>
         <a class="btn-flat white-text circle grey darken-1 waves-effect waves-ripple" style="position:absolute;top:48%;right:0" id="nextQstn" @click="plusDivs(1)">
          <i class="icon ion-chevron-right"></i><i class="icon ion-chevron-right"></i>
        </a>
        <a class="btn-flat white-text circle grey darken-1 waves-effect waves-ripple" style="position:absolute;top:48%;left:0" id="previousQstn" @click="plusDivs(-1)">
          <i class="icon ion-chevron-left"></i><i class="icon ion-chevron-left"></i>
        </a>
      </div>
    </div>
    <!-- Slides card -->
    <div class="white-text darken-3">
      <div class="row">
        <div class="col s12 m4  animated bounceInUp">
          <div class="card grey darken-3">
            <div class="card-content white-text">
              <span class="card-title text-center blue btn">Latest News</span>
              <p v-html="latestNews.title"></p>
            </div>
            <div class="card-action center-align text-center">
              <a>
                <div class="fb-share-button col s1" data-href="https://www.pmg-c.org" data-layout="button" data-size="large" data-mobile-iframe="true"><a target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.facebook.com%2FPlatinummathsteam%2F&amp;src=sdkpreparse" class="fb-xfbml-parse-ignore"></a></div>
              </a>
              <!-- <a href="http://twitter.com/share?text=THIS%20IS%20MY%20SCHOOL,%20I%20MUST%20FIND%20IT%22,%20OVERALL%20WINNER%20OF%20PLATINUM%20REASONING%20CONTEST%202017%20LAMENTED!&url=https://www.pmg-c.org" class="blue btn waves-effect white-text"><i class="icon ion-social-twitter x2" ></i>Tweet</a> -->
                <!-- <i class="icon ion-social-linkedin x2 blue-text white"></i> -->
              <!-- <router-link class="right btn black waves-effect waves-ripple" to="/news">Read More</router-link> -->
              <a class="right btn waves-effect black waves-ripple" @click="toLatestNews(latestNews.randomId)">More</a>
            </div>
          </div>
        </div>
        <div class="col s12 m4">
          <div class="card grey darken-3">
            <div class="card-content white-text animated flip center-align">
              <span class="card-title text-center btn grey darken-4">Our Vision</span>
              <p>To be a leading company that is committed to rejuvenating the dwindling interest in the teaching, learning and application of academic’s knowledge acquired to real-life problems.</p>
            </div>
            <div class="card-action center-align text-center">
            </div>
          </div>
        </div>
        <div class="col s12 m4">
          <div class="card grey darken-3">
            <div class="card-content white-text animated fadeInRightBig">
              <span class="card-title text-center red btn" style="height: auto;">Our Achievements</span>
              <li><router-link to="/achievements/#agFMC" class="white-text">AG'S FMC</router-link></li>
              <!-- <br> -->
              <li><router-link to="/achievements" class="white-text">SUCESSFUL COMPLETION OF PLATINUM REASONING CONTEST 2017</router-link></li>
            </div>
            <div class="card-action">
              <a>
                <div class="fb-share-button col s1" data-href="https://www.pmg-c.org" data-layout="button" data-size="large" data-mobile-iframe="true"><a target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.facebook.com%2FPlatinummathsteam%2F&amp;src=sdkpreparse" class="fb-xfbml-parse-ignore"></a></div>
              </a>
              <!-- <a href="http://twitter.com/share?text=THIS%20IS%20MY%20SCHOOL,%20I%20MUST%20FIND%20IT%22,%20OVERALL%20WINNER%20OF%20PLATINUM%20REASONING%20CONTEST%202017%20LAMENTED!&url=https://www.pmg-c.org" class="blue btn waves-effect white-text"><i class="icon ion-social-twitter x2" ></i>Tweet</a> -->
                <!-- <i class="icon ion-social-linkedin x2 blue-text white"></i> -->
              <router-link class="right btn waves-effect black waves-ripple" to="/achievements">More</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- This is the main content of home page -->
    <br/>
    <div class="row">
      <h3 class="text-center center-align" id="ourPrograms">Our Programs</h3>
      <br/><br/>
      <div class="col s12 m4 z-depth-2">
        <div class="card">
          <div class="card-image">
            <img src="../assets/programs/top-winners.jpg" class="responsive-img" alt="Platinum Reasoning Contest 2017 Top Winners">
            <span class="card-title">PRC 2017</span>
          </div>
          <div class="card-content">
            <p>PRC 2017 denoting Platinum Reasoning Contest organized for students in tertiary institutions throughout the nation as at 2017. </p>
          </div>
          <div class="card-action blue grey-text center-align text-center">
            <a href="http://twitter.com/share?text=PMGC%20organized%20PRC%202017%20denoting%20Platinum%20Reasoning%20Contest%20for%20students%20in%20tertiary%20institutions&url=https://www.pmg-c.org" class="grey darken-2 btn waves-effect blue-text"><i class="icon ion-social-twitter x2" ></i>&nbsp;<span class="white-text">Tweet</span></a>
          </div>
        </div>
      </div>
      <div class="col s12 m4" style="margin-top: -3%;">
        <div class="card">
          <div class="card-image center-align">
            <h2 class="header" style="padding: 2.1rem 0;">PMGC Coding BootCamp</h2>
          </div>
          <div class="card horizontal">
            <div class="card-stacked">
              <div class="card-content">
                <p>Let your child take over from <b>Elon Musk Jeff Bezous, Mark Zuckerberg & Bill Gates...</b>.<br/>
                <!-- <span> Publicity is currently ongoing.</span> -->
                </p><br/>
                <!-- <router-link to="/about-platinum-reasoning-contest-2018" class="btn right grey darken-2 waves-effect waves-light">Know more...</router-link> -->
                <router-link to="/bootcamp" class="amber-text bold btn btn-flat red animated pulse infinity white-text text-center center-align waves-ripple">Know more...</router-link>
              </div>
              <div class="card-action center-align text-center">
              <span>
                <!-- Have you registered for PRC2018? -->
                <!-- Click  &nbsp; <router-link to="/login" class="amber-text bold btn btn-flat red animated pulse infinity white-text text-center center-align waves-ripple" target="_blank" style="text-transform: lowercase; height: auto; padding: 0 8px;" > here </router-link>   &nbsp;to take your examination. -->
              </span>
                <!-- <router-link class="btn btn-flat red animated pulse infinity white-text text-center center-align waves-ripple" style="height: auto;" :to="regInstructions" disabled>Registration Closed!</router-link> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col s12 m4 z-depth-1">
        <div class="card">
          <div class="card-image">
            <img src="../assets/programs/ag.jpg" class="responsive-img" alt="AG fantastic mathematics competition under PMGC winners-picture">
            <span class="card-title">AG'S FMC</span>
          </div>
          <div class="card-content">
            <p>AG FMC organized a mathematics competition for secondary schools in Nigeria.</p>
          </div>
          <div class="card-action blue grey-text center-align text-center">
            <router-link class="btn waves-effect waves-ripple grey darken-2" to="/achievements">More...</router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- Members of the team -->
    <div class="row">
      <br><br>
      <h3 class="text-center center-align" id="teamMembers"><i class="icon ion-android-contacts"></i> &nbsp;Our Team
        <!-- <router-link to="/members-survey"><i class="icon ion-compose btn grey tooltipped"  title="Fill member survey"></i></router-link> -->
      </h3>
      <br/><br/>
      <div class="col s12 m6 l3 offset-m3 offset-l1">
        <div class="card">
          <div class="card-image">
            <img src="../assets/members/makinde.jpg" class="responsive-img" style="height: 307px">
            <span class="card-title">Dr. Mrs. Deborah O. Makinde</span>
          </div>
          <div class="card-content">
            <span class="black-text bold" style="font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen-Sans,Ubuntu,Cantarell,'Helvetica Neue',sans-serif">Head of Educational <wbr/>Services and consultancy</span><br/><br/>
            <p>She is a complex analyst and educationist who has taught at all levels of education and  presently a Senior ...</p>
          </div>
          <div class="card-action blue grey-text center-align text-center">
            <a class="btn waves-effect grey darken-2 waves-ripple">More...</a>
          </div>
        </div>
      </div>
      <div class="col s12 m6 l3 offset-m3">
        <div class="card">
          <div class="card-image">
            <img src="../assets/members/jaiyeola.jpg" class="responsive-img" style="height: 307px">
            <span class="card-title">Dr. Temitope G. Jaiyeola</span>
          </div>
          <div class="card-content">
            <span class="black-text bold" style="font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen-Sans,Ubuntu,Cantarell,'Helvetica Neue',sans-serif">Head of Human <wbr/>Resources Management</span><br/><br/>
            <p>Senior lecturer in the Department of Mathematics, Obafemi Awolowo University Ile-Ife... </p>
          </div>
          <div class="card-action blue grey-text center-align text-center">
            <a class="btn waves-effect grey darken-2 waves-ripple">More...</a>
          </div>
        </div>
      </div>
      <div class="col s12 m6 l3 offset-m3">
        <div class="card">
          <div class="card-image">
            <img src="../assets/members/president22.jpg" class="responsive-img" style="height: 307px">
            <span class="card-title">Mr. Abdulkadri G. Agboola</span>
          </div>
          <div class="card-content">
            <span class="black-text bold" style="font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen-Sans,Ubuntu,Cantarell,'Helvetica Neue',sans-serif">Coordinator<wbr/></span><br/><br/>
            <p>He participated in National Mathematics Competition for Polytechnic Students (NAMCPS) in 2012... </p>
          </div>
          <div class="card-action blue grey-text center-align text-center">
            <a class="btn waves-effect grey darken-2 waves-ripple">More...</a>
          </div>
        </div>
         <router-link to="/members" class="btn red white-text right">Learn more...</router-link>
      </div>
      <!-- <div class="col s12 m6 l3 offset-m3">
        <div class="card">
          <div class="card-image">
            <img src="../assets/members/fin sec.jpg" class="responsive-img" style="height: 307px">
            <span class="card-title">Mr. Olaniyan Oluwatosin</span>
          </div>
          <div class="card-content">
            <span class="black-text bold" style="font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen-Sans,Ubuntu,Cantarell,'Helvetica Neue',sans-serif">Data Analyst<wbr/></span><br/><br/><br/>
            <p>He is a Data Analyst.<br/>he has National Diploma (ND) in Statistics from Departmen... </p>
          </div>
          <div class="card-action blue grey-text center-align text-center">
            <a class="btn waves-effect grey darken-2 waves-ripple">More...</a>
          </div>
        </div>
        <router-link to="/members" class="btn red white-text right">Learn more...</router-link>
      </div> -->
    </div>
    <!-- Our sponsors and co sponsors -->
    <div class="row">
      <br/><br/>
      <h3 class="text-center center-align"  id="sponsors"><i class="icon ion-android-contacts"></i>&nbsp;Sponsors and Co. Sponsors</h3>
      <br/><br/>
      <div class="col s12 m6 white offset-m3">
        <div class="card-image center-align">
          <img src="../assets/sponsors/adeboye.jpg" alt="sponsor" class="responsive-img circle img">
        </div>
        <h2 class="header x15 center-align">
        Pastor E.A. Adeboye
        </h2>
        <div class="card-panel blue-grey center-align">
          <span class="white-text center-align">The General Overseer of Redeemed Christian Church of God (RCCG)
          </span>
        </div>
      </div>
    </div>
    <!-- <a href="" class="right blue lighten-2 white-text toBottom"><i class="icon ion-chevron-down x25"></i></a> -->
    <footer-page/>
    <router-view></router-view>
  </div>
</template>

<script>
import Navbar from '@/components/layouts/navbar'
// import M from 'materialize-css'
// import Loading from '@/components/loading'
import FooterPage from '@/components/layouts/footer-page'
import fetchService from '@/services/fetchService'
import $ from 'jquery'
export default {
  components: {Navbar, FooterPage},
  data () {
    return {
      slideAuto: 0,
      sIndex: 1,
      regInstructions: `/platinum-reasoning-contest-2018-registration-instructions`,
      latestNews: ``
    }
  },
  async mounted () {
    // initializing home page slide show
    var slideIndex = 1
    this.showSlides(slideIndex)
    if (this.$route.fullPath === `/`) {
      this.autoSlide()
    }
    try {
      const allNews = (await fetchService.fetchNews()).data
      if (allNews) {
        this.latestNews = allNews[0]
      }
    } catch (error) {
      if (error.response.data) {
        alert(error.response.data)
      } else {
        console.log(JSON.stringify(error))
      }
    }
    // var elem = document.querySelector('#tTip')
    // eslint-disable-next-line
    // var instance = new M.Tooltip(elem, {
    //   position: 'top'
    // })
  },
  methods: {
    autoSlide () {
      if (this.$route.fullPath === `/`) {
        $('.carousel-item').addClass('animated slideInRight')
        var i
        var x = document.getElementsByClassName('carousel-item')
        for (i = 0; i < x.length; i++) {
          x[i].style.display = 'none'
        }
        this.slideAuto++
        if (this.slideAuto > x.length) {
          this.slideAuto = 1
        }
        x[this.slideAuto - 1].style.display = 'block'
        setTimeout(this.autoSlide, 6500)
      }
    },
    plusDivs (n) {
      if (n === -1) {
        $('.carousel-item').removeClass('slideInRight')
        $('.carousel-item').addClass('slideInLeft')
      } else {
        $('.carousel-item').removeClass('slideInLeft')
        $('.carousel-item').addClass('slideInRight')
      }
      this.showSlides(this.sIndex += n)
    },
    showSlides (n) {
      var i
      var x = document.getElementsByClassName('carousel-item')
      if (n > x.length) {
        this.sIndex = 1
      }
      if (n < 1) {
        this.sIndex = x.length
      }
      for (i = 0; i < x.length; i++) {
        x[i].style.display = 'none'
      }
      x[this.sIndex - 1].style.display = 'block'
    },
    toLatestNews (id) {
      this.$router.push(`/news${encodeURIComponent(`8A7n4d&{random}[id]%6$equals`)}-${id}`)
    }
  }
}
</script>

<style>
/* div.index-page #enclosedSlide > a:nth-child(1) > img {
  height: 400px;
} */
#app > div > div.white-text.darken-3 > div > div.col.s12.m4.animated.bounceInUp > div > div.card-action > a > div > a {
  margin-right: 0px
}
div.index-page > div.white-text.darken-3 > div > div.col.s12.m4 > div > div.card-action > a {
  margin-top: -0.5rem;
}
div.index-page .carousel {
    overflow: hidden;
    position: relative;
    width: 100%;
    height: 630px;
    min-height: auto !important;
    perspective: 500px;
    transform-style: preserve-3d;
    transform-origin: 0 50%;
  }
  div.index-page div:nth-child(10) > div > div.card-image > img {
    width: 180px;
    height: 180px;
    border: 2px groove #546e7a
  }
  div.index-page > div:nth-child(9) > div > div > div.card-image > span {
    font-weight: 600;
    text-transform: uppercase;
    font-size: 1.3rem;
  }
  div.index-page > div.white-text.darken-3 > div > div:nth-child(3) > div > div.card-content.white-text.animated.fadeInRightBig > li {
    list-style-type: square;
    text-decoration: underline;
  }
  div.index-page div.white-text.darken-3 div.card-action > a > i {
  padding: 0.2rem;
}
  div.index-page div.white-text.darken-3 div > div.card-action > a.right.btn.transparent.waves-effect, #app > div > div.row > div > div > div.card-action.blue.grey-text.center-align.text-center > a {
    border-bottom: 3px solid #fff;
  }
  div.index-page div.white-text.darken-3 div > div p {
    /* font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; */
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    text-transform: uppercase;
  }
  div.index-page div.white-text.darken-3 {
    margin-top: -2.5rem;
  }
  div.header-text {
    position: absolute;
    left: 0;
    right: 0;
    top: 35%;
  }

  div.index-page .carousel.carousel-slider .carousel-item {
    height: auto;
    min-height: auto;
  }
  div.index-page .col.s12.m6.white.offset-m3 {
    margin-top: 1rem;
  }
  div.index-page > div.carousel.carousel-slider > a.carousel-item.active {
    height: auto;
  }
  div > div.header-text.text-center.center-align.white-text > h4 {
    background-color: rgba(0, 0, 0, .3);
    border-radius: 15px;
    padding: 1.5rem;
    width: 55%;
    font-weight: bold;
    margin: 0 auto;
  }
  .carousel {
    width: 100%;
  }
  .carousel .carousel-item {
    visibility: visible !important;
  }
  /* .carousel .carousel-item>img {
    filter: brightness(.5)
  }*/

  .flex-container {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: center;
}
div.index-page > div.white-text.darken-3 > div > div.col.s12.m4 > div > div.card-content.white-text > span {
  height: auto;
}
.row {
  width: 100%;
}
.flex-item {
  padding: 5px;
  width: 200px;
  height: 150px;
  margin: 10px;
  line-height: 150px;
  color: white;
  font-weight: bold;
  font-size: 3em;
  text-align: center;
}

.toBottom {
  left: 10%;
  border: 2px groove sandybrown;
}
@media only screen and (min-width: 993px)
  .row .col.offset-l1 {
    margin-left: 12.733333%;
  }
</style>



// WEBPACK FOOTER //
// src/pmgc/index.vue